import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getData'
})
export class GetDataPipe implements PipeTransform {

    transform(obj: any, column: { id: string, path?: Array<string>, libelle: string }): any {
        let path = (column.path != undefined) ? column.path : column.id;
        if (typeof path === 'string') {
            return this.getData(obj, new Array<string>((<string>path)));
        }
        return this.getData(obj, Object.assign(new Array<string>(), path));
    }

    private getData(obj: any, column: Array<string>): any {
        if (typeof obj === 'object') {
            if (column.length != 0) {
                let key: string = column.shift();
                if (obj[key] !== undefined) {
                    return this.getData(obj[key], column);
                }else{
                    return "";
                }
            }
        }
        return obj;
    }

}
